import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db, storage } from "../../../firebase";
import {
  collection,
  addDoc,
  serverTimestamp,
  doc,
  setDoc,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Modal from "../../../components/Modal/Modal";
import styles from "./CompanyForm.module.css";

const CompanyForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    ceo: "",
    established: "",
    industry: "",
    shares: "",
    parValue: "",
    employees: "",
    call: "",
    website: "",
    address: "",
  });

  const [logo, setLogo] = useState(null);
  const [modalMessage, setModalMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  // 입력값 변경 핸들러
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // 파일 선택 핸들러
  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      setLogo(e.target.files[0]);
    }
  };

  // 회사 등록 함수
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (Object.values(formData).some((val) => val === "") || !logo) {
      showModal("⚠️ 모든 필드를 입력해주세요!");
      return;
    }

    try {
      const formattedCompanyName = formData.name.replace(/\s+/g, "_"); // 띄어쓰기 → 언더스코어("_") 변환

      const storageRef = ref(storage, `companyLogos/${logo.name}`);
      await uploadBytes(storageRef, logo);
      const logoURL = await getDownloadURL(storageRef);

      await setDoc(doc(db, "companies", formattedCompanyName), {
        ...formData,
        logo: logoURL,
        createdAt: new Date(),
      });

      showModal("✅ 회사 등록이 완료되었습니다!", true);
    } catch (error) {
      showModal(`❌ 등록 실패: ${error.message}`);
    }
  };

  // 모달 열기 함수
  const showModal = (message, redirect = false) => {
    setModalMessage(message);
    setIsModalOpen(true);

    // 성공 시 2초 후 회사 목록 페이지로 이동
    if (redirect) {
      setTimeout(() => {
        closeModal();
        navigate("/admin/companies"); // 등록 후 회사 목록으로 이동
      }, 2000);
    }
  };

  // 모달 닫기 함수
  const closeModal = () => {
    setIsModalOpen(false);
    setModalMessage("");
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>회사 등록</h2>
      <form onSubmit={handleSubmit} className={styles.form}>
        <input
          type="text"
          name="name"
          placeholder="회사명"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="ceo"
          placeholder="CEO"
          value={formData.ceo}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="established"
          placeholder="설립일 (ex: July 2003)"
          value={formData.established}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="industry"
          placeholder="산업군"
          value={formData.industry}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="shares"
          placeholder="총 주식 수"
          value={formData.shares}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="parValue"
          placeholder="액면가"
          value={formData.parValue}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="employees"
          placeholder="직원 수"
          value={formData.employees}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="call"
          placeholder="전화번호"
          value={formData.call}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="website"
          placeholder="웹사이트"
          value={formData.website}
          onChange={handleChange}
          required
        />
        <textarea
          name="address"
          placeholder="주소"
          value={formData.address}
          onChange={handleChange}
          required
        />
        <input type="file" accept="image/*" onChange={handleFileChange} />
        <button type="submit">회사 등록</button>
      </form>

      {/* 모달 컴포넌트 사용 */}
      {isModalOpen && <Modal message={modalMessage} onClose={closeModal} />}
    </div>
  );
};

export default CompanyForm;
